<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon>fa-exclamation</v-icon> Alertas:
                    <v-spacer/>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    />

                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="alerts"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        ref="table"
                >
                    <template v-slot:item.user="{ item }">

                       {{ item.user.first_name + ' ' + item.user.last_name }}
                    </template>
                    <template v-slot:item.createdAt="{ item }">

                        {{ item.createdAt.toDate() | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                                small
                                class="mr-2"
                        @click="setRoute(item.id)">
                            fa-eye
                        </v-icon>
                    </template>

                </v-data-table>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Alerts",
        data(){
            return{
                search:'',
                dialog:false,
                headers: [
                    {
                        text: 'Usuario',
                        align: 'left',
                        sortable: true,
                        value: 'user',
                    },
                    { text: 'Asunto', value: 'note' },
                    { text: 'Dirección', value: 'address' },
                    { text: 'Creado', value: 'createdAt' },
                    { text: 'Opciones', value: 'actions' },


                ],
            }
        },
        methods:{
            setRoute(value){
                this.$router.push('/alerts/' + value)
            }
        },
        computed:{
            ...mapState({
                alerts:state =>state.alert.alerts
            })
        }
    }
</script>

<style scoped>

</style>